<template>
  <div style="padding: 20px;">
    <!-- 按钮区域 -->
    <div style="margin-bottom: 15px;">
      <el-button type="primary" @click="getAndPreviewFile" :loading="loading">
        获取文件并预览
      </el-button>
      <el-button style="margin-left: 10px;" @click="printFile" :disabled="!previewUrl">
        打印文档
      </el-button>
    </div>

    <!-- 文件预览区域 -->
    <iframe
      v-if="previewUrl"
      :src="previewUrl"
      frameborder="0"
      style="width: 100%; height: 700px; border: 1px solid #eee;"
    ></iframe>
    <div v-else style="color: #999; text-align:center; padding: 100px 0;">
      点击上方按钮获取文件进行预览
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'FilePreviewPrint',
  data() {
    return {
      loading: false,
      previewUrl: '', // 预览地址
      // 你要传给后端的病历数据（替换成你的表单即可）
      formData: {
        name: '张三',
        gender: '男',
        age: '30',
        phone: '13800138000',
        // ... 其他字段
      }
    }
  },
  methods: {
    // 1. 获取文件流并生成预览地址
    async getAndPreviewFile() {
      this.loading = true
      this.previewUrl = 'https://testqywechatapi.178590.com/crm/Word/create'

      // try {
      //   const res = await axios({
      //     method: 'post',
      //     url: 'https://testqywechatapi.178590.com/crm/Word/create',
      //     data: this.formData, // 传给后端的参数
      //     responseType: 'blob', // 【关键】必须写，接收文件流
      //   })

      //   // 生成浏览器可预览的 blob 地址
      //   const blob = new Blob([res.data], {
      //     type: res.headers['content-type'] // 自动识别 Word/PDF
      //   })
      //   this.previewUrl = URL.createObjectURL(blob)

      //   this.$message.success('文件加载成功，正在预览')
      // } catch (err) {
      //   this.$message.error('文件获取失败')
      //   console.error(err)
      // } finally {
      //   this.loading = false
      // }
    },

    // 2. 打印预览的文件
    printFile() {
      if (!this.previewUrl) {
        this.$message.warning('请先获取文件')
        return
      }
      const iframe = document.querySelector('iframe')
      iframe.contentWindow.focus()
      iframe.contentWindow.print()
    }
  },
}
</script>